/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class LoadMore extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }
  handleClick() {
    const nextPageLink = this.dataset.nextPage;

    fetch(nextPageLink)
      .then((response) => {
        return response.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const productGrid = document.querySelector('.ProductListWrapper .ProductList');
        const newProducts = doc.querySelector('.ProductListWrapper .ProductList').innerHTML;
        productGrid.insertAdjacentHTML('beforeend', newProducts);

        productGrid.querySelectorAll('.ProductItem').forEach((item) => {
          item.style.visibility = 'visible';
        });

        const newLoadMore = doc.querySelector('.collection__pagination load-more');
        if (newLoadMore) {
          this.dataset.nextPage = newLoadMore.dataset.nextPage;
          this.classList.remove('tw-hidden');
        } else {
          this.classList.add('tw-hidden');
        }
      })
      .catch((error) => {
        this.addEventListener('click', this.handleClick);
        console.error('Error loading more products:', error);
      });
  }
}
customElements.define('load-more', LoadMore);
